// extracted by mini-css-extract-plugin
export default {"MainDiv":"list_MainDiv__qUP24","MainCard":"list_MainCard__bIs6C","PageTitleWrap":"list_PageTitleWrap__hd8Dk","PageTitle":"list_PageTitle__nbXCT"};